import { render, staticRenderFns } from "./ProductSeting.vue?vue&type=template&id=2025c661&scoped=true&"
import script from "./ProductSeting.vue?vue&type=script&lang=js&"
export * from "./ProductSeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2025c661",
  null
  
)

export default component.exports